export const appTypes = {
    APP_SIDEBAR_COLLAPSE : "APP_SIDEBAR_COLLAPSE",
    APP_SUBNAVBAR_TITLE : "APP_SUBNAVBAR_TITLE",
};
  
  